export default "__VITE_ASSET__$ZmCY6Ay__"